import { connect } from 'react-redux';
import SelectSearch from 'react-select-search';
import React, { useState, useEffect } from 'react';

import Card from 'components/common/Card';
import TextInput from 'components/TextInput';

import { updateOrder } from 'actions/orders';
import { fetchStratas, fetchStrata } from 'actions/stratas';
import { strataSelector, strataCertSelector } from 'selectors/order-create';

import {
  FlexItem,
  FlexContain,
  StepTitle,
  ContentContain,
  StepInformation,
  StepSubTitle,
  MarginBottom
} from '../CreateStyled';

import { stepStrata as handleValidate } from '../validation/';

import CertificateItem from '../CertificateItem';

import { FORM1 } from 'constants/orders';

export const StepStrata = ({
  order,
  stratas,
  orderType,
  updateOrder,
  inputErrors,
  strataName,
  fetchStrata,
  fetchStratas,
  includeOther,
  renderActions,
  selectedStrata,
  selectedStrataCert
}) => {
  const [name, setName ] = useState(order.strata_name || '');

  useEffect(() => {
      fetchStratas({ includeOther, state: order.address_state });
    }, [includeOther, fetchStratas, order.address_state ]);

  useEffect(() => {
    if (selectedStrata) {
      fetchStrata(selectedStrata.id);
    }
  }, []);

  const handleChange = (name, value) => {
    setName(value)
  };

  const handleNext = () => {
    updateOrder({
      strata_name: name,
      strata_other: selectedStrata && selectedStrata.is_other
    });

    return handleValidate({
      name,
      orderType,
      selectedStrata,
      selectedStrataCert
    });
  };

  const handleCertSelect = (certId) => {
    updateOrder({ selected_strata_cert: certId });
  };

  const mapStrataOptions = () =>
    ([{name: 'No Strata Required', id: ''}].concat(stratas))
      .map((strata) => ({ strata, name: strata.name, value: strata.id }));

  const renderCertificates = () => {
    return selectedStrata.items &&
    selectedStrata.items.map((item) => (
      <CertificateItem
        item={item}
        key={item.id}
        selected={(selectedStrataCert && selectedStrataCert.id) === item.id}
        onClick={handleCertSelect.bind(null, item.id)}
        />
    ))
  };

  return (
    <React.Fragment>
      <Card.Content>
        <ContentContain>
          <StepTitle>Strata / Community Title Search</StepTitle>
          <StepInformation>Does this property require a Strata or Community Title search?</StepInformation>

          <StepSubTitle>Strata Management</StepSubTitle>
          <MarginBottom>
            <SelectSearch
              value={(selectedStrata && selectedStrata.id)}
              name="strata-select"
              placeholder="Select / Search Strata Management"
              options={mapStrataOptions()}
              onChange={({ value, strata }) => {
                updateOrder({ selected_strata: value });
                fetchStrata(value);
              }}
            />
          </MarginBottom>


          {(selectedStrata && (            
            <FlexContain>
              <FlexItem flex={2}>{renderCertificates()}</FlexItem>
            </FlexContain>
          ))}

          {(selectedStrata && selectedStrata.is_other &&
            <div>
              <StepSubTitle>Strata Details</StepSubTitle>
              <TextInput
                bold
                name="name"
                value={name}
                label="Strata Name"
                onChange={handleChange}
                placeholder="Strata Name"
                errorText={inputErrors.name}
              />
            </div>
          )}

          {renderActions({
            disableNext: orderType === 'STRATA_SEARCH' && (!selectedStrata || !selectedStrataCert),
            onNext: handleNext
          })}
        </ContentContain>
      </Card.Content>
    </React.Fragment>
  );
};

StepStrata.defaultProps = {
  inputErrors: {},
  onValueChange: () => null
};

export default connect(
  (state) => ({
    stratas: state.stratas.items,
    order: state.pendingOrder.pending,
    inputErrors: state.error.inputErrors,
    selectedStrata: strataSelector(state),
    selectedStrataCert: strataCertSelector(state)
  }),
  {
    dispatchGetStrata: fetchStrata,
    dispatchGetStratas: fetchStratas,
    dispatchOrderUpdate: updateOrder
  }
  )(props =>
  <StepStrata
    {...props}
    fetchStrata={props.dispatchGetStrata}
    fetchStratas={props.dispatchGetStratas}
    updateOrder={props.dispatchOrderUpdate}
    includeOther={props.orderType === FORM1}
  />
);

